import { createFileRoute, Link, useLocation, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { AuthCard } from "@/components/auth-card";
import { AcceptInvitationForm } from "@/features/reseller/accept-invitation/form";
import { m } from "@/lib/paraglide/messages.js";

// /join#<token>: where an invitation's mail lands. The token is the URL's fragment, which no
// request carries, so no proxy or access log holds it; it is read once into this page's state,
// then dropped from the address bar so it is neither bookmarked nor kept in history (guide, rule 31).
export const Route = createFileRoute("/(public)/join")({
  component: JoinPage,
});

function JoinPage() {
  const { hash } = useLocation();
  const [token] = useState(hash);
  const navigate = useNavigate();

  useEffect(() => {
    if (hash) void navigate({ to: ".", hash: "", replace: true });
  }, [hash, navigate]);

  return (
    <AuthCard
      title={m.join_title()}
      description={m.join_description()}
      footer={
        <>
          {m.apply_have_account()} <Link to="/login">{m.common_sign_in()}</Link>
        </>
      }
    >
      <AcceptInvitationForm token={token} />
    </AuthCard>
  );
}
